import React, { createContext, useContext } from 'react';
import { BASE_THEME_ID } from '../constants/constants';
import { getIsDarkTheme } from '../selectors/getIsDarkTheme';
import { getRawPalette } from '../selectors/getRawPalette';
import { MiniPalette } from '../schema/MiniPalette';
import { observer } from 'mobx-react-lite';

export interface ThemeContextState {
    isDarkTheme: boolean;
    palette: MiniPalette;
}

export const ThemeContext = createContext<ThemeContextState>({
    isDarkTheme: false,
    palette: getRawPalette(BASE_THEME_ID, false),
});

export const useTheme = (): ThemeContextState => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useLineageContext must be used within a ThemeProvider');
    }
    return context;
};

export const ThemeProvider = observer(
    ({ children }: { children: JSX.Element }): JSX.Element => {
        const isDarkTheme = getIsDarkTheme();
        const palette = getRawPalette();

        const themeContextValue: ThemeContextState = {
            isDarkTheme,
            palette,
        };
        return <ThemeContext.Provider value={themeContextValue}>{children}</ThemeContext.Provider>;
    }
);
